"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _colors = require("HubStyleTokens/colors");

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UIImage = _interopRequireDefault(require("UIComponents/image/UIImage"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _ProductPageIcons = _interopRequireDefault(require("ui-addon-upgrades/_core/productPage/ProductPageIcons"));

var _responsiveBreakpoints = _interopRequireDefault(require("../../utils/responsiveBreakpoints"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    &:not(:last-child) {\n      &:after {\n        display: none;\n      }\n    }\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var ProductContainer = _styledComponents.default.div.withConfig({
  displayName: "ProductList__ProductContainer",
  componentId: "sc-1avk0s4-0"
})(["display:flex;align-items:center;&:not(:last-child){margin-right:20px;&::after{margin-left:20px;font-weight:normal;color:", ";content:'|';}}", ";"], _colors.BATTLESHIP, _responsiveBreakpoints.default.phone(_templateObject()));

var Product = function Product(_ref) {
  var iconKey = _ref.iconKey,
      body = _ref.body;
  return _react.default.createElement(ProductContainer, null, _react.default.createElement(_UIImage.default, {
    className: "display-inline m-right-2",
    height: 13,
    width: 13,
    src: _ProductPageIcons.default[iconKey],
    responsive: false
  }), _react.default.createElement("span", null, body));
};

var ProductList = function ProductList(_ref2) {
  var edition = _ref2.edition;
  var langBase = 'pricingPage.pages.growthSuite';
  return _react.default.createElement(_UIFlex.default, {
    wrap: "wrap"
  }, _react.default.createElement(Product, {
    iconKey: "crm",
    body: _react.default.createElement(_FormattedMessage.default, {
      message: langBase + ".crm"
    })
  }), _react.default.createElement(Product, {
    iconKey: "marketing",
    body: _react.default.createElement(_FormattedMessage.default, {
      message: langBase + ".marketing." + edition
    })
  }), _react.default.createElement(Product, {
    iconKey: "sales",
    body: _react.default.createElement(_FormattedMessage.default, {
      message: langBase + ".sales." + edition
    })
  }), _react.default.createElement(Product, {
    iconKey: "service",
    body: _react.default.createElement(_FormattedMessage.default, {
      message: langBase + ".service." + edition
    })
  }));
};

var _default = ProductList;
exports.default = _default;
module.exports = exports.default;